import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { Flex, Text } from '@moonpig/launchpad-components'
import { IconSystemSearch } from '@moonpig/launchpad-assets'
import { HighlightText } from '../HighlightText'
import { SuggestionItemType, SuggestionRow } from '../types'
import { LIST_ICON_SIZE_PX } from '../constants'

const StyledIconWrapper = styled(Flex)`
  ${s({
    bgcolor: 'colorBackground01',
    borderRadius: 1,
    p: 4,
    mr: 4,
    color: 'colorInteractionControl',
  })}
`
const StyledText = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  ${s({
    borderRadius: 2,
  })}
`

type SuggestionProps = {
  row: SuggestionRow
  value: string
} & React.HTMLProps<HTMLElement>

export const Suggestion: FC<React.PropsWithChildren<SuggestionProps>> = ({
  row,
  value,
}) => {
  const item = row.item as SuggestionItemType

  return (
    <Flex alignItems="center">
      <StyledIconWrapper data-testid="suggestions-search-icon">
        <IconSystemSearch
          width={LIST_ICON_SIZE_PX}
          height={LIST_ICON_SIZE_PX}
        />
      </StyledIconWrapper>

      <StyledText>
        <HighlightText text={item.value} value={value} />
      </StyledText>
    </Flex>
  )
}
